var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgGlobe = function SvgGlobe(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 15,
    "data-width-24": 22,
    viewBox: "0 0 14.8 14.8",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M7.37 14.139A6.77 6.77 0 1 0 7.37.6a6.77 6.77 0 0 0 0 13.539"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M7.37 14.139c1.529 0 2.769-3.031 2.769-6.77S8.899.6 7.369.6 4.6 3.63 4.6 7.37c0 3.738 1.24 6.769 2.77 6.769M1.062 9.831h12.615M1.062 4.908h12.615"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGlobe);
export default ForwardRef;